import React, { Fragment } from "react";
import { Query } from "react-apollo";
import gql from "graphql-tag";
import List from "./list";
import AddButton from "./add-item-button";

const QUERY = gql`
  query {
    allLayers {
      id
      name
      description
      isDefault
    }
  }
`;

const LayersIndex = props => {
  return (
    <Fragment>
      <Query query={QUERY}>
        {({ loading, error, data }) => {
          if (loading || error) {
            return null;
          }
          const { allLayers } = data;
          return <List items={allLayers} query={QUERY} />;
        }}
      </Query>
      <AddButton query={QUERY} />
    </Fragment>
  );
};

export default LayersIndex;



// WEBPACK FOOTER //
// ./src/components/admin/carto/layers/index.js